import { useEffect, useState } from 'react'

// Hook to check if 'window' is available
export function useIsClient(): boolean {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    // This will be true only in the browser environment
    setIsClient(typeof window !== 'undefined')
  }, [])

  return isClient
}
